import PropTypes from "prop-types";
import React from "react";
import {
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
} from "react-native";
import { isWeb } from "../../../../helpers/utils";
import ExitTutorialsButton from "../header/ExitTutorialsButton";

import CloseIcon from "./CloseIcon";
import appStyles from "../../../appStyles";

export default class DialogContainer extends React.PureComponent {
  static propTypes = {
    blurComponentIOS: PropTypes.node,
    buttonSeparatorStyle: PropTypes.object,
    children: PropTypes.node.isRequired,
    contentStyle: PropTypes.object,
    footerStyle: PropTypes.object,
    headerStyle: PropTypes.object,
    blurStyle: PropTypes.object,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    visible: false,
  };

  render() {
    const {
      buttonSeparatorStyle = {},
      children,
      contentStyle = {},
      footerStyle = {},
      headerStyle = {},
      blurStyle = {},
      onClose = () => {},
    } = this.props;
    const titleChildrens = [];
    const descriptionChildrens = [];
    const buttonChildrens = [];
    const otherChildrens = [];
    React.Children.forEach(children, (child) => {
      if (!child) {
        return;
      }
      if (
        child.type.name === "DialogTitle" ||
        child.type.displayName === "DialogTitle"
      ) {
        titleChildrens.push(child);
      } else if (
        child.type.name === "DialogDescription" ||
        child.type.displayName === "DialogDescription"
      ) {
        descriptionChildrens.push(child);
      } else if (
        child.type.name === "DialogButton" ||
        child.type.displayName === "DialogButton"
      ) {
        if (buttonChildrens.length > 0) {
          buttonChildrens.push(
            <View style={[styles.buttonSeparator, buttonSeparatorStyle]} />,
          );
        }
        buttonChildrens.push(child);
      } else {
        otherChildrens.push(child);
      }
    });
    return (
      <View style={styles.modal}>
        <TouchableWithoutFeedback onPress={() => onClose()}>
          <View style={[styles.blur, blurStyle]} />
        </TouchableWithoutFeedback>

        <ExitTutorialsButton style={{ right: 10 }} />

        <View style={styles.container}>
          <View style={[styles.content, appStyles.maxWidth, contentStyle]}>
            {this.props.showCloseButton ? (
              <CloseIcon onPress={this.props.onClose} />
            ) : null}

            <View style={[styles.header, headerStyle]}>
              {titleChildrens}
              {descriptionChildrens}
            </View>
            {otherChildrens}
            {Boolean(buttonChildrens.length) ? (
              <View style={[styles.footer, footerStyle]}>
                {buttonChildrens.map((x, i) =>
                  React.cloneElement(x, {
                    key: `dialog-button-${i}`,
                  }),
                )}
              </View>
            ) : null}
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  modal: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: -30,
    right: -3,
    zIndex: 100,
    elevation: 11,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
    overflow: "hidden",
  },
  blur: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    maxWidth: "100%",
  },
  content: {
    width: "100%",
    minWidth: 300,
    flexDirection: "column",
    borderRadius: 4,
    backgroundColor: "#FFF",
    overflow: "hidden",
    elevation: 4,
    padding: isWeb ? 13 : 26,
    margin: 16,
    marginHorizontal: 23,
  },
  header: Platform.select({
    ios: {
      marginHorizontal: 20,
      marginVertical: 10,
    },
    android: {
      marginHorizontal: 20,
      marginVertical: 10,
    },
    web: {
      margin: 12,
    },
  }),
  footer: Platform.select({
    ios: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderTopColor: "#A9ADAE",
      borderTopWidth: StyleSheet.hairlineWidth,
      height: 46,
    },
    android: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      marginTop: 10,
    },
    web: {
      borderTopColor: "#A9ADAE",
      borderTopWidth: StyleSheet.hairlineWidth,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 10,
    },
  }),
  buttonSeparator: {
    height: "100%",
    backgroundColor: "#A9ADAE",
    width: StyleSheet.hairlineWidth,
  },
});
